import * as React from 'react';

// The context we are getting from pageContext values
export default React.createContext({});
